'use client';

import type { BaseLabelProps } from 'src/app/_components/base/label';
import BaseLabel from 'src/app/_components/base/label';
import { cn } from 'src/app/lib/utils/tailwindcss';

type LabelProps = BaseLabelProps;

function KottonseedLabel({ className, ...props }: LabelProps) {
  return <BaseLabel className={cn('typo-body-5 text-[#454545]', className)} {...props} />;
}

export default KottonseedLabel;
